// Dependencies
import React from 'react';
import CoreView from 'Core/containers/CoreView';
import { injectIntl, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Container, Paper } from '@mui/material';
import Tabs, { TabContainer } from 'Components/Tabs';
import { useLocation } from 'react-router-dom';

// Own Components
import InboxTab from './components/inboxTab';

import './main.scss';
// Components
import AlersTab from './components/alertsTab';



const AlertsMainView = () => {

	const { messages } = useIntl()
	const location = useLocation()

	let path = location.pathname.split("/");
	let id = path[path.length - 1];
	id = id ? parseInt(id) : 0;

	return (
		<Container maxWidth={false} className="container-view">
			<Paper elevation={0}>
				<Tabs tab={id || 0}>
					<TabContainer label={messages['alertsTabView_Alert']} index={0}>
						<AlersTab />
					</TabContainer>
					{/* 
						<TabContainer label={messages['inboxTabView_Inbox']} index={1} >
							<InboxTab/>
						</TabContainer>
						*/}
				</Tabs>
			</Paper>
		</Container>
	);
}

const mapStateToProps = () => {
	return {};
};

export default injectIntl(connect(mapStateToProps, {})(AlertsMainView));
